module.exports = __webpack_public_path__ + "static/dentons-206e313993de140b729211ef094b9967.png";